<!--  -->
<template>
 <div class="worksItem">
   <div class="topBar">
     <div class="select">
       <span class="active" @click="selectBytypes(0,$event)">默认</span>
       <span  @click="selectBytypes(1,$event)">投票数</span>
       <span  @click="selectBytypes(2,$event)">浏览量</span>
     </div>

  <el-select v-model="value" placeholder="请选择搜索条件"
:popper-append-to-body="false">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.label">
      </el-option>
    </el-select>

     <div class="searchBar">
        <i @click="searchWorks()" ></i>
        <input type="text" @keyup.enter="searchWorks()" v-model="searchText" placeholder="输入作者或作品编号或名称">
     </div>
   </div>
    <ul class="itemList" v-if="dataList.length > 0">
        <li @click="detailink(item.id)" v-for="item in dataList" :key="item.id">
          <img :src="getImage(item.cover)" alt="">
          <div class="name">
            <i
            :class="{
              rank1:item.rank===1,
              rank2:item.rank===2,
              rank3:item.rank===3
            }"
            ></i>
            <!-- <i class="rank2"></i>
            <i class="rank3"></i> -->
            <span> {{item.worksTitle}}</span>
          </div>
          <div class="info">
            <p><span>作者：</span>{{item.author}}</p>
            <p><span>编号：</span>{{item.authorNo}}</p>
            <p><span>浏览：</span>{{item.pv}}</p>
          </div>
          <div class="toupiao" :class="{ 'vote': !voteType }">
            <span>{{item.voteCount}}</span>|<span v-if="voteType" @click.stop="addPiao(item.id,$event)">投票</span><span v-if="!voteType">投票</span>
          </div>
        </li>
    </ul>
      <el-pagination
      hide-on-single-page
        @current-change="handleCurrentChange"
        :page-size="params.limit"
        :pager-count="5"
        layout="prev, pager, next"
        :total="total"
        class="pagemodel1">
      </el-pagination>
      <h2 class="nodata" v-if="dataList.length === 0">暂无数据</h2>
 </div>
</template>

<script>
import {getWorkItemList, getToupiao} from '@/api/workCollect/index'
export default {
  name: 'worksItem',
  components: {

  },
  data () {
    return {
      options: [
        {
          value: '按作者进行搜索',
          label: '1'
        }, {
          value: '按作者编号进行搜索',
          label: '2'
        }, {
          value: '按作品名称进行搜索',
          label: '3'
        }
      ],
      searchText: '',
      value: '',
      params: {
        page: 1,
        limit: 8,
        activityId: this.activityId,
        author: null,
        authorNo: null,
        worksTitle: null,
        voteCountSort: null,
        pvSort: null
      },
      dataList: [],
      total: 0,
      columnId: '',
      activityIds: ''
    }
  },
  props: ['activityId', 'voteType'],
  created () {
    this.activityIds = this.$route.query.id
    this.columnId = this.$route.query.columnId
    this.getWorkItemLists()
  },
  methods: {
    addPiao (id, e) {
      getToupiao(id, this.$cookie.get('wlyuserid')).then(res => {
        console.log(res, 'piao')
        console.log(e.target.previousSibling.previousSibling)
        this.$alert(res.data.message, '', {
          confirmButtonText: '确定',
          callback: () => {
            if (res.data.status === 200) {
              e.target.previousSibling.previousSibling.innerText = Number(e.target.previousSibling.previousSibling.innerText) + Number(1)
            }
          }
        })
      })
    },
    getWorkItemLists () {
      getWorkItemList(this.params).then(res => {
        console.log(res, 'nhj')
        this.dataList = res.data.data.rows
        this.total = res.data.data.total
        if (this.params.page === 1) {
          this.addRank(this.dataList)
        }

        console.log(this.dataList)
      })
    },
    selectBytypes (type, e) {
      this.params.page = 1
      if (type === 0) {
        this.params.voteCountSort = null
        this.params.pvSort = null
        this.getWorkItemLists()
      } else if (type === 1) {
        this.params.voteCountSort = 'desc'
        this.params.pvSort = null
        this.getWorkItemLists()
      } else if (type === 2) {
        this.params.voteCountSort = null
        this.params.pvSort = 'desc'
        this.getWorkItemLists()
      }
      let childs = e.target.parentNode.childNodes
      for (var i = 0; i < childs.length; i++) {
        if (childs[i].nodeName === 'SPAN') {
          childs[i].classList.remove('active')
          console.log(childs[i].classList)
        }
      }
      e.target.classList.add('active')
    },
    searchWorks () {
      this.params.page = 1
      if (this.value === '') {
        this.$message.error('请选择搜索条件')
      } else if (this.value === '1') {
        this.params.author = this.searchText
        this.params.authorNo = null
        this.params.worksTitle = null
        this.getWorkItemLists()
      } else if (this.value === '2') {
        this.params.author = null
        this.params.authorNo = this.searchText
        this.params.worksTitle = null
        this.getWorkItemLists()
      } else if (this.value === '3') {
        this.params.author = null
        this.params.authorNo = null
        this.params.worksTitle = this.searchText
        this.getWorkItemLists()
      }
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getWorkItemLists()
    },
    addRank (arr) {
      arr.forEach((item, index) => {
        if (index === 0) Object.assign(item, {rank: 1})
        if (index === 1) Object.assign(item, {rank: 2})
        if (index === 2) Object.assign(item, {rank: 3})
      })
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    detailink (id) {
      if (this.$cookie.get('wlyuserid') === undefined || this.$cookie.get('wlyuserid') === null) {
        this.$router.push({path: '/login', query: {redirect: this.$router.currentRoute.fullPath}})
      } else {
        this.$router.push({
          path: 'worksItemDetail',
          query: {
            worksId: id,
            columnId: this.columnId,
            activityId: this.activityIds,
            voteType: this.voteType
          }
        })
      }
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
// .el-select-dropdown{
//   position: absolute !important;
//   top: 600px !important;
// }
@import '../../assets/common/scss/works.scss'
</style>



// WEBPACK FOOTER //
// src/components/worksItem/index.vue